import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { linkNotifySubscriberContactMethodToPerson } from "../../../queries/notify";
import { buildNotifyInfiniteSubscriberContactMethodsQueryKey } from "./useInfiniteNotifySubscriberContactMethods";
import { buildNotifyContactsQueryKey } from "./useInfiniteNotifyContacts";
import { buildNotifySubscriberContactMethodsQueryKey } from "./useNotifySubscriberContactMethodsForLoggedInUser";

interface IUseNotifySubscriptionPreferenceUpdate {
  onSuccess?: (
    res: {
      subscriberContactMethodId: number;
      subscriptionGroupId: number;
      subscriptionGroup: { name: string };
      type: string;
    }[],
  ) => void;
  onError?: (error: unknown) => void;
}

export function useNotifySubscriberContactMethodLink({
  onSuccess,
  onError,
}: IUseNotifySubscriptionPreferenceUpdate = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [linkSubscriberContactMethodMutation, { isLoading: isLinkSubscriberContactMethodLoading }] = useMutation(
    linkNotifySubscriberContactMethodToPerson(networkHeaders),
    {
      onSuccess: async (data) => {
        await queryCache.invalidateQueries(buildNotifyInfiniteSubscriberContactMethodsQueryKey());
        await queryCache.invalidateQueries(buildNotifyContactsQueryKey());
        await queryCache.invalidateQueries(buildNotifySubscriberContactMethodsQueryKey());
        if (onSuccess) {
          onSuccess(data);
        }
      },
      onError: onError,
    },
  );

  const linkSubscriberContactMethod = async ({
    subscriberContactMethodId,
    personId,
  }: {
    subscriberContactMethodId: number;
    personId: number;
  }) => {
    return await linkSubscriberContactMethodMutation({
      id: subscriberContactMethodId,
      body: { userId: personId },
    });
  };

  return { linkSubscriberContactMethod, isLinkSubscriberContactMethodLoading };
}
